var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganicTopShape = function SvgOrganicTopShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2204 792",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.926 642.5c-436.333-112.167 0-750.5 0-750.5H2125.43c88.16 138 175.8 481.3-179 750.5s-1316.171 112.167-1752.504 0Z"
  })));
};
export default SvgOrganicTopShape;